/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { getAccountIds } from './accountData.js';

var supportsContentBody = function supportsContentBody(method) {
  return ['put', 'post', 'patch'].find(function (m) {
    return m === method.toLowerCase();
  });
};
var getDefaultHeaders = function getDefaultHeaders(method) {
  var defaultHeaders = {
    Accept: 'application/json'
  };
  // Only set Content-Type header for request methods that support a content body
  if (supportsContentBody(method)) {
    defaultHeaders['Content-Type'] = 'application/json';
  }
  return defaultHeaders;
};
var getHeaders = function getHeaders(_ref) {
  var _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'GET' : _ref$method,
    _ref$headers = _ref.headers,
    headers = _ref$headers === void 0 ? {} : _ref$headers,
    enableBssAccountHeader = _ref.enableBssAccountHeader,
    enableImsAccountHeader = _ref.enableImsAccountHeader,
    accountIds = _ref.accountIds,
    isPolling = _ref.isPolling;
  var requestHeaders = _objectSpread2(_objectSpread2({}, getDefaultHeaders(method)), headers);
  var _accountIds = _slicedToArray(accountIds, 3),
    bssAccount = _accountIds[0],
    imsAccount = _accountIds[1],
    contextId = _accountIds[2];

  // Add account headers to ensure account scoped tokens
  // https://github.ibm.com/Console-Platform/console-platform-express-session#account-scoped-tokens
  if (bssAccount && enableBssAccountHeader) {
    requestHeaders['X-BSS-Account'] = bssAccount;
  }
  if (contextId && enableBssAccountHeader) {
    requestHeaders['IBM-Account-Context'] = contextId;
  }
  if (imsAccount && enableImsAccountHeader) {
    requestHeaders['X-IMS-Account'] = imsAccount;
  }
  if (isPolling) {
    requestHeaders['IBM-Is-Polling'] = 'true';
  }
  return requestHeaders;
};
function request(url, options) {
  return getAccountIds().then(function (accountIds) {
    var newOptions = _objectSpread2(_objectSpread2({}, options), {}, {
      headers: getHeaders(_objectSpread2(_objectSpread2({}, options), {}, {
        accountIds: accountIds
      }))
    });
    return fetch(url, newOptions);
  });
}

export { request as default };
